// extracted by mini-css-extract-plugin
module.exports = {"preset__header":"presets_preset__header__ZrB5d","preset__tag-view":"presets_preset__tag-view__Un7Ng","preset__trending":"presets_preset__trending__OcLHf"};